import * as types from './mutations-types'

export default {
  [types.SET_SNACK_MESSAGE] (state, snackMessage) {
    state.snackMessage = snackMessage
  },
  [types.SET_FILTERS] (state, filters) {
    state.filters = filters
  },
  [types.SET_HEADER_HEIGHT] (state, height) {
    state.headerHeight = height
  },
  [types.RESET_STEPS_FILLING] (state, height) {
    state.filledSteps = {
      stepA: false,
      stepB: false,
      stepC: false
    }
  },
  [types.SET_STEP_FILLED] (state, stepName) {
    if (!Object.prototype.hasOwnProperty.call(state.filledSteps, stepName)) {
      return
    }
    state.filledSteps = {
      ...state.filledSteps,
      [stepName]: true
    }
  },
  [types.SET_FILTER_ROW_SHOWN_STATE] (state, shown = false) {
    state.filterRowShown = shown
  },
  [types.UPDATE_INIT_COUNT] (state, initNumber) {
    state.initCount = initNumber
  }
}
